import { types as t } from 'mobx-state-tree';
import { AbstractExplanation } from '../abstract-explanation.store';

export const AbstractReadingExplanation = AbstractExplanation.props({
  range: t.maybeNull<any>(t.string),
});
